module.exports = __webpack_public_path__ + "static/media/site-profile.1744fd19.jpeg";